import { NavLink } from 'react-router-dom';
import { Home, Users, BookOpen, MessageSquare, Menu } from 'lucide-react';

export function AdminBottomNav({ onMore }) {
  const items = [
    { to: '/admin/dashboard', label: 'Home', icon: Home, testid: 'admin-bn-home' },
    { to: '/admin/clients', label: 'Clients', icon: Users, testid: 'admin-bn-clients' },
    { to: '/admin/training', label: 'Programs', icon: BookOpen, testid: 'admin-bn-programs' },
    { to: '/admin/messages', label: 'Messages', icon: MessageSquare, testid: 'admin-bn-messages' },
  ];
  return (
    <nav className="fixed bottom-0 inset-x-0 z-30 lg:hidden glass safe-bottom border-t border-[var(--c-hair)]">
      <div className="px-2 py-2 grid grid-cols-5 gap-1 max-w-2xl mx-auto">
        {items.map(({ to, label, icon: Icon, testid }) => (
          <NavLink key={to} to={to} data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center py-1.5 rounded-xl transition-all relative ${
                isActive ? 'text-[#00C8FF]' : 'text-muted-foreground'
              }`
            }>
            {({ isActive }) => (<>
              {isActive && <span className="absolute top-0 h-0.5 w-8 rounded-full bg-[#00C8FF] shadow-[0_0_12px_rgba(0,200,255,0.8)]" />}
              <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 1.8} />
              <span className="text-[10px] mt-0.5 font-medium">{label}</span>
            </>)}
          </NavLink>
        ))}
        <button onClick={onMore} data-testid="admin-bn-more" className="flex flex-col items-center justify-center py-1.5 rounded-xl text-muted-foreground active:text-[#00C8FF]">
          <Menu className="w-5 h-5" strokeWidth={1.8} />
          <span className="text-[10px] mt-0.5 font-medium">More</span>
        </button>
      </div>
    </nav>
  );
}
